import { Component, OnInit, ElementRef } from '@angular/core';
import { PageBase, RentalInfo } from 't4core';
import { LayoutService } from 'app-components';
import { NavigationService } from 'app-components';
import { ActiveRentalService } from 'app-components';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarService } from '../../../../../projects/app-components/src/lib/Services/SnackbarService/snackbar.service';

@Component({
  selector: 'app-pickup-complete',
  templateUrl: './pickup-complete.component.html',
    styleUrls: ['./pickup-complete.component.css'],
    standalone: false
})
export class PickupCompleteComponent extends PageBase implements OnInit {
  public booking: RentalInfo;
  constructor(el: ElementRef, private aviationService: NavigationService, private rentalService: ActiveRentalService, private layoutService: LayoutService, private snackbarService: SnackbarService) {
    super(el);
  }

  async ngOnInit(): Promise<void> {
    this.booking = await this.rentalService.getBooking();
    if (this.rentalService.offerReceived) {
      this.showSnackbar();
      this.rentalService.offerReceived = false;
    }

    setTimeout(() => this.next(), 2500);
  }


  showSnackbar() {
    this.snackbarService.openSnackBar('New offer from: ' + this.booking.PickupLocation.Name, "MyPage/Campaigns");
  }



  public async next() {
    this.aviationService.executeCommand("Next");
  }
}
